import React from 'react';

import { Typography } from '../../../Typography';

import styles from './TableLabel.module.scss';

export interface ITableLabelProps {
    label: string;
}

export const TableLabel: React.FC<ITableLabelProps> = ({ label }) => {
    return (
        <div className={styles.labelContainer}>
            <Typography variant="h5">{label}</Typography>
        </div>
    );
};
